import React, {Component} from "react";
import {Button, Checkbox, Input, message, Modal,Empty} from "antd";
import $ from "jquery";
import {uuid} from "../../../../utils/index";
import * as PropTypes from "prop-types";
import IconFont from "../../../components/svgIcon/IconFont";
import Activiti from "../../../activiti/Activiti"
import svgList from "../image/svgList";
import {showBtnConfig} from "./showBtn-config";
import BaseComponent from "../../../../base/BaseComponent";
import SyncModal from "../../../components/syncModal/syncModal";
import {Scrollbars} from "react-custom-scrollbars";
const {TextArea} = Input;
const { Search } = Input;
/**
 * 审核流组件
 * @description 组件传入数据和方法，返回流程按钮或流程弹窗
 * @class ActivitiModal
 * @extends {Component}
 */
class ActivitiModal extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            btns: []
        };
    }

    componentDidMount() {
        this.initAct();
    }

    render() {
        const {title, visible, onlyShowBtn} = this.props;
        const {btns} = this.state;
        return (
            <>
                {
                    onlyShowBtn ?
                        <>{btns}</> :
                        <Modal
                            title={title}
                            visible={visible}
                            footer={<div style={{display: "flex",justifyContent:"flex-end"}}>
                                {btns}
                            </div>}
                            width={1200}
                            // onCancel={() => this.onModalHide()}
                        >
                            {React.Children.map(this.props.children, child => child)}
                        </Modal>
                }
                <SyncModal ref={ref=>this.syncModal=ref}/>
            </>
        );
    }

    storyId = "";

    /**
     * 初始化流程
     * @param {Function} Activiti 流程的构造函数
     */
    initAct = () => {
        const {renderButtons, setState, modalHide} = this;
        const {dataSource,id,userAccount, onSubmitOK,
            saveFunction, saveStatusNameFunction, readyCall, successCall,
            showBtnFlag,otherJs,showAfterFuns,showRemarks,publish,successMsg,
            chooseFilterObject,checkForm,closeServiceTemp=[]
        } = this.props;
        // 获取参数
        const activitiConfs = this.getActivitiConfs();
        const pojoName = this.getPojoName();
        const againFlag = this.props.againFlag || false;

        let that = this;
        // 设置参数 Activiti.createActivit(options, call);
        const options = {
            uuid: id,//主键id
            activitiConf: activitiConfs,
            pojoName: pojoName,//数据库表单名
            userAccount: userAccount,
            showBtnFlag: showBtnFlag!==false?true:false,//btn强制显隐判定
            againFlag: againFlag,//流程新开判定
            showAfterFuns: showAfterFuns,
            // getTextRequisite:false  //备注必填判定
            render: function () {},
            otherJs: otherJs,
            closeServiceTemp,
            success: function (activiti) {   //对象创建成功回调
                activiti.getChoose =function(data,type,call){
                    if (data && data.length) {
                        let checkedObj = that.showPeople(data,type);
                        window.loading.hide();
                        that.syncModal.confirm({
                            title: "人员选择",
                            width: 400,
                            content:checkedObj.render(),
                            okText: "确定",

                            cancelText: "取消",
                            onOk: () => {
                                let checkeds = checkedObj.getChecked();
                                let peopleArray = [];
                                checkeds&&checkeds.length&&checkeds.forEach((item,index)=>{
                                    peopleArray.push({
                                        userId:item._id,
                                        deptId:item.deptData[0]._id,
                                    })
                                });
                                let obj ={};
                                obj.data = peopleArray;
                                if(!peopleArray.length){
                                    message.destroy();
                                    message.warn('请至少选择一项!');
                                    return
                                }
                                window.loading.show();
                                obj.type ="activitiUsers";
                                that.syncModal.destroy(()=>{
                                    call&&call.call(activiti,obj);
                                });
                            },
                            onCancel: () => {
                                that.syncModal.destroy();
                            }
                        });
                    } else {
                        window.loading.hide();
                        message.warning('未查到流程候选人，请联系管理员进行设置');
                    }
                };

                if(typeof chooseFilterObject === "function") {
                    // 过滤审核流推进时的选人 activiti.options.item.document.lineJavaScript.chooseFilterOn == true 流程参数成立时会过滤选人
                    activiti.chooseFilterObject = chooseFilterObject
                }

                if(typeof checkForm === "function") {
                    // 流程推进之前先校验数据  otherJs中存在 doNotCheckForm 时不校验数据，否则默认在流程按钮点击之前先校验数据
                    activiti.checkForm = checkForm
                }

                //重写推进前保存方法
                activiti.afterSave = function (activiti, call) {
                    saveFunction(activiti, function (res) {
                        if (res && res.id) {
                            that.storyId = res.id;
                            call(res);
                        } else {
                            activiti.load.end();
                            // activiti.error("保存后返回参数错误！"); // 这里不一定是调保存后报错
                        }
                    });
                };
                activiti.endFunction = function (activiti, call) {  //流程推进后的回调一般用作推进后修改状态
                    let statusName = activiti.options.statusNameTemp;
                    let publishStatusConfig = that.sysConfigGetValueByKey("act_publish_name","已发布");
                    if(statusName === publishStatusConfig) {
                        publish(statusName, activiti, call);
                    } else {
                        saveStatusNameFunction(statusName, activiti, call);
                    }
                };
                activiti.getActivitiKey = function (activitiConf, call) {
                    // [{type: "website"}]
                    let treeCode = activitiConfs[0]["type"];
                    if(treeCode){
                        activiti.post("/cm-sites-sys/activitiBindTree/getByconf", {treeCode}, function (res) {
                            if (res && res.activitiApp && res.activitiApp.key) {
                                call(res.activitiApp.key);
                            } else {
                                call(false);
                            }
                        }, "json");
                    }else{
                        console.log(`activitiConf.type 为 ${treeCode}`);
                        call(false);
                    }
                };
                //重写回显批注信息
                activiti.showRemarks = function (remarks) {
                    if (remarks && remarks.length) {
                        showRemarks && showRemarks(remarks);
                        // that.syncModal.confirm({
                        //     title: "备注",
                        //     width: 400,
                        //     content: <TextArea value={remarks} placeholder={"请输入"} maxLength={200} rows={2}
                        //                        style={{width: 350, height: 64, fontSize: 14}}
                        //                        ref={(remarksTextArea) => that.remarksTextArea = remarksTextArea}/>,
                        //     okText: "确定",
                        //     cancelText: "取消",
                        //     footer: <Button onClick={()=>{that.syncModal.destroy();}}>关闭</Button>,
                        //     onOk: () => {
                        //         that.syncModal.destroy();
                        //     },
                        //     onCancel: () => {
                        //         that.syncModal.destroy();
                        //     }
                        // });
                    }
                };
                //重写创建按钮的方法
                activiti.renderButton = function (buttons = [], call) {
                    renderButtons(buttons, call, activiti, activitiConfs);
                };
                activiti.load = {
                    start: function () {
                        window.loading.show();
                        // message.loading("处理中...");
                    },
                    end: function () {
                        window.loading.hide();
                    }
                };
                activiti.error = function (res) {
                    let msg = res.msg;
                    if(typeof res === "string"){
                        msg=res;
                    }
                    message.destroy();
                    message.error(msg, 1);
                };
                activiti.successMsg = function (res, call) {
                    if(successMsg){
                        successMsg(res,1,call);
                    }else{
                        message.success(res, 1, call);
                    }
                };
                activiti.submitOK = function (call) { //流程推进成功后的提示点击确定的回调，一般用来关闭窗口或刷新
                    //关闭窗口
                    onSubmitOK(activiti);
                };
                if (Activiti.util.isFunction(successCall)) {
                    successCall(activiti);
                }
                activiti.getText = function (data,type,callback,options) {
                    window.loading.hide();
                    that.syncModal.confirm({
                        title: "备注",
                        width:400,
                        content : <TextArea key={uuid()} placeholder={"请输入"} maxLength={200} rows={2} style={{width:350, height:64, fontSize:14}} ref={(remarksTextArea)=>that.remarksTextArea = remarksTextArea}/>,
                        okText: "确定",
                        cancelText: "取消",
                        onOk: ()=>{
                            if(
                                options && options.notNull && (!that.remarksTextArea?.state?.value?.length || !that.remarksTextArea.state.value.trim()?.length)
                            ){
                                // activiti.error({
                                //     msg : "请填写备注！"
                                // });
                                message.destroy();
                                message.warning("请填写备注！");
                                return;
                            }
                            window.loading.show();
                            that.syncModal.destroy(()=>{
                                callback.call(activiti,{remarks: that.remarksTextArea.state.value,type:"remarks"});
                            });
                        },
                        onCancel: ()=>{
                            that.syncModal.destroy();
                            activiti.load.end();
                        }
                    });
                }
            },

        };

        Activiti.createActivit(options, function (activiti) {
            if(id){
                this.getHistory(function (res) {});
            }
            if (Activiti.util.isFunction(readyCall)) {
                readyCall(activiti);
            }
        });
    };


    showPeople(data,type,call){

        let that = this;
        let obj = {
            newData: data,
            data: JSON.parse(JSON.stringify(data)),
            render: function () {
                let _this = this;

                return (
                    <div key={uuid()} >
                        {/*<Search*/}
                        {/*    placeholder="请输入"*/}
                        {/*    allowClear*/}
                        {/*    onSearch={function(val){*/}
                        {/*        _this.newData = _this.data.filter(item=>item.name.indexOf(val)>-1);*/}
                        {/*        that.syncModal.againRender(_this.render());*/}
                        {/*    }}*/}
                        {/*    style={{ width: '100%',marginBottom:24 }}*/}
                        {/*/>*/}
                        <Scrollbars   autoHeight
                                      autoHide
                                      autoHeightMax={300}>

                                {_this.newData&&_this.newData.length?<div style={{display:"flex", flexWrap:'wrap'}}>{
                                    _this.newData.map((item,index)=>{
                                        let departName =item.deptData[0].name;

                                        return(
                                            <div key={item.id} style={{width:'50%',marginBottom:5}}>
                                                <Checkbox onChange={(e)=>{data[index].checked = e.target.checked}}>
                                             <span className={'twoText'}  title={item.name +"（"+departName+"）"} style={{display: "inline-block",position: "relative",
                                                 top: '5px',
                                                 width: "140px"}}>{item.name}（{departName}）</span>
                                                </Checkbox>
                                            </div>
                                        )
                                    })
                                }</div>:<Empty/>}


                        </Scrollbars>
                    </div>
                )
            },
            getChecked: () => {
                return data.filter(item=>item.checked)
            },
            setChecked: (list) => {
                data = list
            },
        };
        return obj;
    }


    renderButtons = (actButonsdata, call, activiti, activitiConfs) => {
        this.props.btnLoadOver && this.props.btnLoadOver(actButonsdata);
        if (!actButonsdata || actButonsdata.length == 0) {
            actButonsdata = [];
        }

        let that = activiti;
        let activitiModal = this;
        let allBtnComponents = {};
        let actButtons = actButonsdata.map((item, index) => {
            //前置js， 控制按钮的显隐
            let hideStyle = {
                display: "block"
            };
            if (item.document && item.document.lineJavaScript && item.document.lineJavaScript.afterButtonShow && that.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]) {
                hideStyle = {
                    display: "none"
                };
                let func = eval(that.options.showAfterFuns[item.document.lineJavaScript.afterButtonShow]);
                new func(item, (res) => {
                    if (res.code > 0) {
                        if(activitiModal.state.btns[index]) {
                            // console.log("activitiModal.state.btns[index]",activitiModal.state.btns[index])
                            // activitiModal.state.btns[index].props.hideBtn = false;

                            let btnComponent = allBtnComponents["key_" + index];
                            btnComponent.show();
                            // activitiModal.setState({});
                        } else {
                            hideStyle = {
                                display: "block"
                            };
                        }
                    } else if (res.code == 0) {
                        activiti.log("状态：0 ，" + item.document.lineJavaScript.afterButtonShow + ":" + res.log || res.msg);
                    } else {
                        activiti.error(item.document.lineJavaScript.afterButtonShow + ":" + res.log);
                    }
                });
            }

            //流程需要执行的其他js
            let args = [];
            if (item.document.lineJavaScript.otherJs && item.document.lineJavaScript.otherJs.split(",").length > 0) {
                let funArray = item.document.lineJavaScript.otherJs.split(",");
                $.each(funArray, function fun(i, it) {
                    let funtemp = function () {
                        let callback = Activiti.util.getCallbackFn.call(funtemp);
                        let func = that.options.otherJs[funArray[i]];
                        if (func) {
                            func.call(that, that, item, function (res) {
                                if(res.log){
                                    activiti.log(res.log);
                                }
                                if(res.code >0){
                                    callback.call(that,item)
                                }else if(res.code == 0){
                                    console.log( "状态：0 ，" +  funArray[i] + ":" + res.log || res.msg);
                                }else{
                                    that.error(funArray[i] + ":" + (res.msg || res.log || "执行出错！"));
                                }
                            });
                        } else {
                            that.error("未找到前置js：" + funArray[i] + ",请清除浏览器缓存重试。如清理缓存后问题依然存在，请联系管理员。");
                        }
                    };
                    args.push(funtemp);
                });
            }
            args.push(function () {
                that.buttonClick.call(that, item);
            });
            let hideBtn = hideStyle.display === "none";

            let BtnEle;
            let configName = this.props.btnType || "default";
                            // console.log("activitiModal.state.btns",activitiModal.state.btns)
                            // console.log("index",index)
            if(typeof configName == "string"){
                BtnEle = require(`./btnList/${configName}`); // 引入编辑器
            }
            return (
                BtnEle?
                    <BtnEle.default
                        ref={btnComponent => {
                            allBtnComponents["key_" + index] = btnComponent;
                        }}
                        className={'btnStyle'}
                        hideBtn={hideBtn}
                        key={uuid()}
                        onClick={() => {
                            window.loading.show();
                            that.options.item = item;
                            //清空辅助参数
                            activiti.auditorMapTemp = {};
                            activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [];
                            //先执行回退方法，将前置js造成的影响进行回退，然后再执行点击事件
                            Activiti.util.executeFunctionChain(activiti.options.closeServiceTemp,activiti,{},function(){
                                Activiti.util.simpleChainedFn.apply(that, args);
                            })
                        }}
                        icon={
                            this.props.showBtnIcon?<IconFont className={'btnIcon'} type={svgList(item.document.style)} style={{}}/>
                                : ""
                        }
                        btnName={item.btnName || item.name}
                    />
                    :""
            )
            // return <div key={uuid()} className="button_view" style={{...hideStyleOk}}>
            //
            //     {
            //         this.props.showButtonStyle ?
            //             <div>
            //                 {btnStyle(item,() => {
            //                     that.options.item = item;
            //                     //清空辅助参数
            //                     activiti.auditorMapTemp = {};
            //                     activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [];
            //                     Activiti.util.simpleChainedFn.apply(that, args);
            //                 })}
            //             </div>
            //             :
            //     <div className={'btnStyle'} onClick={() => {
            //         that.options.item = item;
            //         //清空辅助参数
            //         activiti.auditorMapTemp = {};
            //         activiti.options._ACT_AUDIOTR_MAP_FORM_SERVICE_USERS = [];
            //         Activiti.util.simpleChainedFn.apply(that, args);
            //     }}>
            //         <IconFont className={'btnIcon'} type={svgList(item.document.style)} style={{}}/>
            //         <span>{item.btnName || item.name}</span>
            //     </div>}
            //     <style>
            //         {
            //             `
            //             .btnStyle {
            //                 color: ${this.props.btnColor?this.props.btnColor:'#ffffff'};
            //
            //             }
            //             `
            //         }
            //     </style>
            // </div>;
        });

        let publishBtnShow = eval(showBtnConfig.publishBtn.evl);
        if(publishBtnShow){
            //mustNotShowPublishBtn 不显示发布按钮
            publishBtnShow = !this.props.mustNotShowPublishBtn && this.props.showBtnFlag && true;
        }
        if(publishBtnShow) {
            let BtnEle;
            let configName = this.props.btnType || "default";
            if(typeof configName == "string"){
                BtnEle = require(`./btnList/${configName}`); // 引入编辑器
            }
            let publishBtn = (
                BtnEle?
                    <BtnEle.default
                        className={'btnStyle'}
                        key={uuid()}
                        onClick={() => {
                            // activiti.options.statusNameTemp = "已发布";
                            activiti.options.statusNameTemp = activitiModal.sysConfigGetValueByKey("act_publish_name","已发布") || "已发布";
                            window.loading.show();
                            activiti.afterSave(that,(res)=>{
                                if(res) {
                                    // activiti.successMsg("稿件保存成功");
                                    activiti.endFunction(that,(res)=>{
                                        if(res) {
                                            activiti.successMsg("正在发布中，请稍后刷新列表查看！", function () {
                                                window.loading.hide();
                                                activiti.submitOK.call(activiti);
                                            });
                                            // activiti.submitOK()
                                        } else {
                                            window.loading.hide();
                                            activiti.error("稿件发布失败")
                                        }
                                    })
                                } else {
                                    window.loading.hide();
                                    activiti.error("稿件保存失败")
                                }
                            })
                        }}
                        icon={
                            this.props.showBtnIcon?<IconFont className={'btnIcon'} type={svgList("act_publish")} style={{}}/>
                                : ""
                        }
                        btnName={"发布"}
                    />
                    :""
            );
            actButtons.push(publishBtn);
        }

        this.setState({
            btns: actButtons
        },()=>{
            if(actButtons&&actButtons.length){
                this.lockStatus();
            }
        });
    };
    //加锁
    lockStatus = () => {
        let id = this.props.id;
        if (!id || !(this.props.showLockCall && typeof this.props.showLockCall=="function")) return false;
        this.lockFactory.tryLock({
            id: id, callback: (data) => {
                this.props.showLockCall && this.props.showLockCall(data);
            }, showNotification: false
        });
    };

    getActivitiConfs = () => {
        const {activitiConf} = this.props;
        return activitiConf ? [activitiConf] : null;
    };

    getPojoName = () => {
        if (this.props.pojoName) {
            return this.props.pojoName;
        } else {
            return message.warning("参数pojoName不能为空！");
        }
    };
}

ActivitiModal.propTypes = {
    // /**
    //  * @text 数据源
    //  * @category data
    //  */
    // dataSource: PropTypes.object.isRequired,

    /**
     * @text 流程id
     * @category string
     */
    id: PropTypes.string,

    /**
     * @text 流程conf
     * @category array
     */
    activitiConf: PropTypes.object,

    /**
     * @text 数据表name
     * @category string
     */
    pojoName: PropTypes.string.isRequired,

    /**
     * @text 当前用户account
     * @category string
     */
    userAccount: PropTypes.string.isRequired,

    /**
     * @text 是否显示流程按钮
     * @category bool
     */
    showBtnFlag: PropTypes.bool,

    /**
     * @text 重置流程的判断条件
     * @category bool
     */
    againFlag: PropTypes.bool,

    /**
     * @text 流程按钮加载前置js
     * @category object
     */
    showAfterFuns: PropTypes.object,

    /**
     * @text 备注是否必填
     * @category bool
     */
    getTextRequisite: PropTypes.bool,

    /**
     * @text 流程按钮点击事件前置js
     * @category object
     */
    otherJs: PropTypes.object,

    /**
     * @text 重写推进前保存方法（保存数据的函数）
     * @category event
     */
    saveFunction: PropTypes.func.isRequired,

    /**
     * @text 推进流程后修改数据状态
     * @category event
     */
    saveStatusNameFunction: PropTypes.func.isRequired,

    /**
     * @text 推进流程后发布稿件
     * @category event
     */
    publish: PropTypes.func,

    /**
     * @text 流程推进结束后的回调（可以在这里执行关闭页面/刷新页面等操作）
     * @category event
     */
    onSubmitOK: PropTypes.func,

    /**
     * @text 流程对象创建成功回调（加载非流程按钮，流程记录）
     * @category event
     */
    successCall: PropTypes.func,

    /**
     * @text 流程初始化完成后的回调
     * @category event
     */
    readyCall: PropTypes.func,

    /**
     * @text 仅返回流程按钮
     * @category bool
     */
    onlyShowBtn: PropTypes.bool,

    /**
     * @text 弹窗title
     * @category string
     */
    title: PropTypes.string,

    /**
     * @text 弹窗是否展示
     * @category bool
     */
    visible: PropTypes.bool,
};
ActivitiModal.defaultProps = {
    dataSource: {},
    id: "",
    showBtnFlag:true,
    againFlag:false,
    showAfterFuns:{},
    getTextRequisite:false,
    otherJs:{},
    onSubmitOK:()=>{},
    successCall:()=>{},
    readyCall:()=>{},
    onlyShowBtn:false,
    title:'审核流弹窗',
    visible:false,
};
export default ActivitiModal
